<template>

    <Head v-if="title" :title="title" />

    <div class="relative z-10 flex-shrink-0 flex h-10 bg-indigo-700 shadow">
        <button v-if="false" class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
            <span class="sr-only">Otevřít postranní menu</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
            </svg>
        </button>
        <div style="justify-content: right;" class="flex-1 px-4 flex justify-between">
            <div class="ml-4 flex items-center md:ml-6">
                <!-- Profile dropdown -->
                <div class="ml-3 relative">
                    <div>
                        <button
                            v-if="$page.props.jetstream.managesProfilePhotos"
                            @click="showUserMenu = !showUserMenu"
                            @focusout="showUserMenu = false"
                            class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" id="user-menu" aria-haspopup="true">
                            <span class="sr-only">Open user menu</span>
                            <img class="h-8 w-8 rounded-full object-cover" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />
                        </button>

                        <button
                            v-else
                            @click="showUserMenu = !showUserMenu"
                            @focusout="showUserMenu = false"
                            class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
                            <div class="text-white">{{ $page.props.user.name }}</div>
                            <div class="ml-1">
                                <svg class="fill-current h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </div>
                        </button>
                    </div>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95"
                    >
                        <div
                            @focusin="showUserMenu = true"
                            @focusout="showUserMenu = false"
                            v-show="showUserMenu"
                            class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">

                            <!-- Account Management -->
                            <div class="block px-4 py-2 text-xs text-gray-400">
                                Správa účtu
                            </div>

                            <jet-dropdown-link :href="route('profile.show')">
                                Profil
                            </jet-dropdown-link>

                            <jet-dropdown-link :href="route('api-tokens.index')" v-if="$page.props.jetstream.hasApiFeatures">
                                API Přístupy
                            </jet-dropdown-link>

                            <div class="border-t border-gray-100"></div>

                            <!-- Team Management -->
                            <template v-if="$page.props.jetstream.hasTeamFeatures">
                                <div class="block px-4 py-2 text-xs text-gray-400">
                                    Správa týmů
                                </div>

                                <!-- Team Settings -->
                                <jet-dropdown-link :href="route('teams.show', $page.props.user.current_team)">
                                    Nastavení týmu
                                </jet-dropdown-link>

                                <jet-dropdown-link :href="route('teams.create')" v-if="$page.props.jetstream.canCreateTeams">
                                    Vytvořit nový tým
                                </jet-dropdown-link>

                                <div class="border-t border-gray-100"></div>

                                <!-- Team Switcher -->
                                <div class="block px-4 py-2 text-xs text-gray-400">
                                    Přepnout tým
                                </div>

                                <template v-for="team in $page.props.user.all_teams" :key="team.id">
                                    <form @submit.prevent="switchToTeam(team)">
                                        <jet-dropdown-link as="button">
                                            <div class="flex items-center">
                                                <svg v-if="team.id === $page.props.user.current_team_id" class="mr-2 h-5 w-5 text-green-400" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                                <div>{{ team.name }}</div>
                                            </div>
                                        </jet-dropdown-link>
                                    </form>
                                </template>

                                <div class="border-t border-gray-100"></div>
                            </template>

                            <!-- Authentication -->
                            <form @submit.prevent="logout">
                                <jet-dropdown-link as="button">
                                    Odhlásit
                                </jet-dropdown-link>
                            </form>

                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>

    <slot></slot>


</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import { useToast } from "vue-toastification";
import LogoImg from "../Components/LogoImg";
import DropdownLink from "../Jetstream/DropdownLink";

export default {
    name: "PartnerLayout",
    components: {
        DropdownLink,
        LogoImg,
        InertiaLink: Link,
        Head,
        'jet-dropdown-link': DropdownLink,
    },

    setup(){
        const toast = useToast();
        return { toast }
    },
    data(){
        return {
            showMainMenu: false,
            showUserMenu: false,
        }
    },
    methods:{

    }
}
</script>

<style scoped>

</style>
